// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9176) return "static/chunks/9176-35e65c5667307965.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1137":"924102770e8ce685","2012":"1b379c31f5b69933","6661":"799844076acb8464","6934":"df6f68706c9b9437"}[chunkId] + ".js";
};